var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11270_76514)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_11270_76514)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.22223,
    y: 2.22223,
    width: 35.5556,
    height: 35.5556,
    rx: 17.7778,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.77778,
    y: 2.77778,
    width: 34.4444,
    height: 34.4444,
    rx: 17.2222,
    stroke: "white",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11270_76514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0382 14.2033C11.9944 12.9769 13.0747 11.8673 14.2865 11.8527C15.5567 11.8527 16.8269 11.8527 18.0971 11.8527C19.3381 11.8965 20.3601 13.0499 20.3309 14.2763C21.6303 14.2763 22.9297 14.2617 24.2291 14.2763C25.3971 14.3201 26.4191 15.3566 26.4337 16.5246C26.4337 19.649 26.4337 22.7734 26.4337 25.8978C26.4191 26.8614 25.7183 27.752 24.7985 28.044C24.4335 28.1754 24.0247 28.1462 23.6451 28.1462C20.5353 28.1462 17.4255 28.1462 14.3157 28.1462C13.1185 28.1462 12.0382 27.0804 12.0382 25.8832C12.0382 21.985 12.0382 18.0868 12.0382 14.2033ZM14.3157 15.9698C13.9215 16.0282 13.6587 16.4224 13.6879 16.8166C13.6879 19.7512 13.6879 22.6712 13.6879 25.6058C13.6295 26.1022 14.0967 26.511 14.5785 26.4526C17.7029 26.4526 20.8127 26.4526 23.9371 26.4526C24.4043 26.4818 24.7693 26.0438 24.7547 25.5912C24.7547 22.6712 24.7547 19.7512 24.7547 16.8166C24.7839 16.3786 24.4189 15.9114 23.9517 15.9406C20.7397 15.9698 17.5277 15.9406 14.3157 15.9698Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6299 17.5759C15.8635 17.5029 16.0971 17.5321 16.3307 17.5175C18.4769 17.5321 20.6231 17.5029 22.7693 17.5321C23.3386 17.5321 23.616 18.3789 23.1926 18.7439C22.9882 19.0066 22.6233 18.9629 22.3313 18.9629C20.1997 18.9483 18.0535 18.9774 15.9219 18.9482C15.1919 18.9774 14.9875 17.8679 15.6299 17.5759Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6736 20.5249C15.878 20.4373 16.1262 20.4665 16.3452 20.4519C18.4914 20.4665 20.623 20.4373 22.7692 20.4665C23.2948 20.4811 23.5868 21.1527 23.2948 21.5761C23.1342 21.8535 22.7838 21.9557 22.4772 21.9265C20.258 21.9265 18.0388 21.9557 15.8196 21.9265C15.1334 21.8097 15.0312 20.7731 15.6736 20.5249Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.805 23.445C18.0242 23.3866 20.2579 23.445 22.4917 23.4158C22.8713 23.372 23.3093 23.5764 23.3823 23.9706C23.4991 24.4378 23.1049 24.9342 22.6231 24.8758C20.3747 24.8758 18.141 24.8904 15.8926 24.8758C15.1042 24.8904 15.002 23.5618 15.805 23.445Z",
    fill: "#64748B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11270_76514",
    x: 0,
    y: 0,
    width: 44.4444,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.44444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.22222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11270_76514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_11270_76514",
    x: 2.22223,
    y: 2.22223,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.44444,
    dy: 4.44444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.44444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11270_76514"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11270_76514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7778,
    height: 17.7778,
    fill: "white",
    transform: "translate(10.5555 11.1119)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimple);
export default __webpack_public_path__ + "static/media/simple.bcfbacf89a1f45c6a35195c1a55f4716.svg";
export { ForwardRef as ReactComponent };